import { Activity } from '../../../lib/types/models/ol/activity/activity'
import { OlRateIdInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getActivity({ id, olId }: OlRateIdInput) {
  return restApiClient.url(constructApiUrl(API.ols.getActivity.url, { id, olId })).get<Activity>()
}
